import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from 'src/hooks';

// Interfaces
import { ForgotPassworFormI } from 'src/interfaces/generalInterface';

//redux
import { setRole } from 'src/redux/slices/auth.slice';

// Components
import Input from 'src/ui/Input';
import DecisionFooter from 'src/ui/layout/DecisionFooter';

const ForgotPasswordForm = (props: ForgotPassworFormI) => {
  const { onSuccess } = props;
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { t } = useTranslation(['forgotPassword']);
  const formik = useFormik({
    initialValues: {
      email: '',
      role: '',
    },
    validateOnChange: true,
    validationSchema: Yup.object({
      email: Yup.string().email(t('emailValid')).required(t('emailError')),
      role: Yup.string().required(t('roleError')),
    }),
    onSubmit: (values) => {
      onSuccess(values);
    },
  });

  return (
    <form onSubmit={formik.handleSubmit} className='mt-8' style={{ width: '85%' }}>
      {formik.touched.role && formik.errors.role ? (
        <div className='text-alert font-medium mt-2 flex justify-center'>{formik.errors.role}</div>
      ) : (
        <span className='text-primary font-medium mt-2 flex justify-center'>{t('chooseRole')}</span>
      )}
      <div className='flex justify-center'>
        <select
          className={` ${
            formik.touched.role && formik.errors.role
              ? 'w-full formUsersInput error1 mt-2 mb-8'
              : 'w-full formUsersInput mt-2 mb-8'
          }`}
          name='role'
          onChange={(e) => {
            formik.handleChange(e), dispatch(setRole(e.target.value));
          }}
          value={formik.values.role}
          onBlur={formik.handleBlur}
          // required={true}
        >
          <option value='' disabled hidden>
            {t('chooseRole')}
          </option>
          <option value=''>{t('chooseRole')}</option>
          {data.map((option: any) => (
            <option value={option.value} key={option.id}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
      {formik.touched.email && formik.errors.email ? (
        <div className='text-alert ml-2 font-medium text-left'>{formik.errors.email}</div>
      ) : (
        <span className='text-primary ml-2 font-medium text-left'>{t('inputOne')}</span>
      )}
      <div className='relative'>
        <Input
          type='email'
          name='email'
          value={formik.values.email}
          onChange={(e) => formik.handleChange(e)}
          onBlur={formik.handleBlur}
          extraClass='w-full mb-4'
          haveError={formik.touched.email && formik.errors.email}
          placeholder={t('inputOne')}
        />
      </div>

      <DecisionFooter
        cancel={t('loginBtn')}
        approve={t('submtBtn')}
        onCancel={() => navigate('/auth')}
      />
    </form>
  );
};

export default ForgotPasswordForm;

const data: any = [
  {
    label: 'Administration',
    value: 'admin',
  },
  {
    label: 'Relationship Coach',
    value: 'coach',
  },
  {
    label: 'Therapist',
    value: 'therapist',
  },
];
